import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import { CPRS_CERTIFICATION_APPLICATION_QUERY } from "@/graphql/cprs-certification-application-query";
import {
  CertificationPartTwoForm,
  FormFieldContents,
  FormNavbar,
  addReference,
  addSupervisor,
} from "@/models/certification-part-two-form/certification-part-two-form.interface";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import { certificationFormApi } from "@/providers/apis/certification-part-two-form";
import DateTimePickerComponent from "../date-time-picker/date-time-picker.component.vue";
import CertificationPartTwoPreviewForm from "../certification-part-two-preview-form/certification-part-two-preview-form.component.vue";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { utils } from "@/utils/utils";
import MultiRadioButton from "../multi-radio-button/multi-radio-button.component.vue";
import moment from "moment";
import { User } from "@/models/common-interface/common.interface";
import ScopeOfActivity from "../scope-of-activity/scope-of-activity-component.vue";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import EligibilityPopupComponent from "../eligibility-qsn-valid-popup/eligibility-qsn-valid-popup.vue";

@Component({
  name: "certification-part-two-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-upload-file": FileUploadComponent,
    "b-form-multi-radio": MultiRadioButton,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-form-date-time-picker": DateTimePickerComponent,
    "certification-preview-form": CertificationPartTwoPreviewForm,
    "code-of-ethics-and-scope-of-activity": ScopeOfActivity,
    AppLoaderComponent,
    ErrorPopupComponent,
    EligibilityPopupComponent,
  },
})
export default class CertificationPartTwoFormComponent extends Vue {
  public isScroll = false;
  public applicationData: Array<CertificationPartTwoForm> = [];
  public applicationNavData: Array<FormNavbar> = [];
  public formData: Array<FormFieldContents> = [];
  public isNavLoad = false;
  public formPagination = 0;
  public isValid = false;
  public fileData: any;
  public previewPayload: any = {};
  public applicantFullDetials: any;
  public formName = "certificationPartTwoApplicationForm";
  public certificateLocationId: any;
  public referenceEmailDuplicateIndexs: number[] = [];
  public supervisorEmailDuplicateIndexs: number[] = [];
  public supervisorFormFields: addSupervisor[] = [];
  public supervisorPayLoadData: any[] = [];
  public signatureInvalid = false;
  public saveDataDraft = false;
  public userDetails: User = {} as User;
  public isReviewerUser: any;
  public formTitle = {
    certificationTitle: "",
    certificationSubTitle: "",
  };
  public certificatePayLoadData: any = {
    fillStatus: "DRAFT",
    certificationPartTwoApplicationForm: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      backupEmail: null,
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
      agencyOrOrganization: "",
      positionOrTitle: "",
      stillEmployed: "",
      startDate: "",
      endDate: "",
      employmentStatus: [],
      completedTennessee: "",
      employedOrVolunteered: "",
      receivedThreeHoursSupervision: "",
      descripePeerSupportResponsibity: "",
    },
    certificationPartTwoSupervisorInformation: [
      {
        supervisorFirstName: "",
        supervisorLastName: "",
        supervisorAgencyOrganization: "",
        supervisorPhone: "",
        supervisorEmail: "",
      },
    ],
    certificationPartTwoRefererenceInformation: [
      {
        firstName: "",
        lastName: "",
        agencyOrganization: "",
        yourPosition: "",
        referencePhoneNumber: "",
        referenceEmailAddress: "",
      },
      {
        firstName: "",
        lastName: "",
        agencyOrganization: "",
        yourPosition: "",
        referencePhoneNumber: "",
        referenceEmailAddress: "",
      },
      {
        firstName: "",
        lastName: "",
        agencyOrganization: "",
        yourPosition: "",
        referencePhoneNumber: "",
        referenceEmailAddress: "",
      },
    ],
    certificationPartTwoHandbook: {
      handbook: {
        codeOfEthics: {
          isCodeofEthicsChecked: [],
          codeofEthicsFirstName: "",
          codeofEthicsLastName: "",
        },
        scopeOfActivity: {
          isScopeofActivityChecked: [],
          scopeofActivityFirstName: "",
          scopeofActivityLastName: "",
        },
      },
    },
    certificationPartTwoSignature: {
      isSignature: "",
      submissionDate: "",
    },
  };
  public isLoading = false;
  public isEdit = false;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public checkValidForm = false;
  public formCompletedIndex: number[] = [];
  public mainId = "app";
  public hideDiv: string[] = ["startDate", "endDate"];
  public checkField: string[] = ["stillEmployed"];
  public addReferenceForm: addReference[] = [];
  public isReferesh = "false";
  public checkSOAValid = false;
  public validSOA = true;
  public errorMessage = "";
  public supervisorEndDateShowIdx: number[] = [];
  public supervisorStartDateShowIdx: number[] = [];
  public supervisorUIUpdate = false;
  public eligibilityPopup = false;
  public eligibilityPopupMsg = "";

  public created() {
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }
  public async mounted() {
    this.userDetails = utils.getUserDetails();
    const token = localStorage.getItem("access_token");
    const formFilledIndex: any = localStorage.getItem("partTwoFormFilledIndex");
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((data: string) => {
        this.formCompletedIndex.push(Number(data));
      });
    }
    // Re-derive step 0 completion from a live validation so a stale mark can't
    // make the finalize gate skip an unfinished Application Form.
    this.syncStepZeroOnLoad();
    if (this.userDetails) {
      const userRolesData = this.userDetails.roles;
      this.isReviewerUser =
        userRolesData && userRolesData.indexOf("REVIEW_APPLICATION") !== -1;
    } else {
      this.isReviewerUser = false;
    }
    let payloadStorage: any = localStorage.getItem(
      "partTwoCertificationPayload"
    );
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.certificatePayLoadData = {
        ...this.certificatePayLoadData,
        ...payloadStorage,
      };
    } else {
      if (
        !this.isReviewerUser &&
        token &&
        this.userDetails &&
        (this.userDetails.roles === null || !this.userDetails.roles)
      ) {
        this.isLoading = true;
        const userDetailsEmail = this.userDetails.email;
        certificationFormApi
          .getCertificateDetials(userDetailsEmail)
          .then((result: any) => {
            this.applicantFullDetials = result.data.data;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.firstName =
              this.applicantFullDetials.certificationPartOneBasicDetails.firstName;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.lastName =
              this.applicantFullDetials.certificationPartOneBasicDetails.lastName;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.phone =
              this.applicantFullDetials.certificationPartOneBasicDetails.phone;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.email =
              this.applicantFullDetials.certificationPartOneBasicDetails.email;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.addressLine1 =
              this.applicantFullDetials.certificationPartOneBasicDetails.addressLine1;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.addressLine2 =
              this.applicantFullDetials.certificationPartOneBasicDetails.addressLine2;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.state =
              this.applicantFullDetials.certificationPartOneBasicDetails.state;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.city =
              this.applicantFullDetials.certificationPartOneBasicDetails.city;
            this.certificatePayLoadData.certificationPartTwoApplicationForm.zip =
              this.applicantFullDetials.certificationPartOneBasicDetails.zip;
            localStorage.setItem(
              "partTwoCertificationPayload",
              JSON.stringify(this.certificatePayLoadData)
            );
            this.isLoading = false;
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      } else {
        this.$router.push({
          name: "login-page",
          query: { application: "certification-part-two-form" },
        });
      }
    }
    if (this.formPagination === 0) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${CPRS_CERTIFICATION_APPLICATION_QUERY}`,
      })
      .then((result) => {
        this.applicationData =
          result.data.cprsCertificationApplicationForms.data;
        this.formTitle = {
          certificationTitle:
            this.applicationData[0].attributes.certificationTitle,
          certificationSubTitle:
            this.applicationData[0].attributes.certificationSubTitle,
        };
        this.applicationNavData =
          this.applicationData[0].attributes.certificationNavbar;
        this.formData =
          this.applicationData[0].attributes.certification_form_fields;
        if (
          this.certificatePayLoadData.certificationPartTwoSupervisorInformation
            .length
        ) {
          const addSupervisorForm =
            this.certificatePayLoadData
              .certificationPartTwoSupervisorInformation.length;
          for (let index = 0; index < addSupervisorForm; index++) {
            this.supervisorFormFields.push(
              this.applicationData[0].attributes.certification_form_fields[1]
                .fields.formInputs[0]
            );
          }
        }
        for (let index = 0; index < this.checkField.length; index++) {
          this.fieldUpdate(this.checkField[index]);
        }
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
        });
      });
    const mainEl: any = document.querySelector(".main-content");
    if (mainEl) {
      mainEl.addEventListener("keyup", (event: any) => {
        if (event.shiftKey && event.keyCode == 9) {
          const el = event.path[0];
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }
      });
    }
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public emptyEvent() {
    return;
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public nextButton() {
    this.checkValidForm = true;
    this.checkSOAValid = !this.checkSOAValid;
    // Finalizing from the signature step must not skip earlier steps: if any is
    // incomplete (free-nav jumped past it), send the user back to it.
    if (this.formPagination === 4) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1 && incomplete !== 4) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    this.certificatePayLoadData.certificationPartTwoApplicationForm.state =
      this.certificatePayLoadData.certificationPartTwoApplicationForm.state.toLocaleUpperCase();
    if (this.formPagination == 3) {
      this.certificatePayLoadData.certificationPartTwoSignature.submissionDate =
        moment().format("MM-DD-YYYY");
    }
    if (this.formPagination == 4) {
      this.certificatePayLoadData.certificationPartTwoSignature.submissionDate =
        moment().format("MM-DD-YYYY");
      if (
        this.certificatePayLoadData.certificationPartTwoSignature.isSignature
      ) {
        this.signatureInvalid = false;
      } else {
        this.checkValidForm = true;
        this.signatureInvalid = true;
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 100);
        return;
      }
    }
    if (
      this.formPagination === 0 ||
      this.formName === "certificationPartTwoApplicationForm"
    ) {
      const content: any = this.formData.find(
        (form) => form.parent_slug === "certificationPartTwoApplicationForm"
      );
      if (
        this.certificatePayLoadData.certificationPartTwoApplicationForm
          .completedTennessee === "No"
      ) {
        this.eligibilityPopupMsg = content.fields.completedTennesseePopupMsg;
        this.eligibilityPopup = true;
        return;
      }
    }
    this.$validator.validateAll().then(async (validate) => {
      if (this.formName === "certificationPartTwoRefererenceInformation") {
        this.referenceEmailDuplicateIndexs = utils.duplicateValueIdx(
          this.certificatePayLoadData,
          this.formName,
          true,
          "referenceEmailAddress"
        );
      }
      if (this.formName === "certificationPartTwoSupervisorInformation") {
        this.supervisorEmailDuplicateIndexs = utils.duplicateValueIdx(
          this.certificatePayLoadData,
          this.formName,
          true,
          "supervisorEmail"
        );
      }

      if (
        this.referenceEmailDuplicateIndexs.length === 0 &&
        this.supervisorEmailDuplicateIndexs.length === 0 &&
        validate &&
        this.validSOA
      ) {
        // The step completed NOW, before nextPaginationUpdate() advances it.
        const completedStep = this.formPagination;
        if (this.formPagination == 1) {
          const supervisorEmailValidate =
            this.certificatePayLoadData.certificationPartTwoSupervisorInformation.filter(
              (supervisor: any) => {
                if (
                  supervisor.supervisorEmail.toLowerCase() ===
                  this.certificatePayLoadData.certificationPartTwoApplicationForm.email.toLowerCase()
                ) {
                  return supervisor;
                }
              }
            );
          if (supervisorEmailValidate.length) {
            this.errorMessage =
              "Supervisor email id and applicant email id must be different *";
            return;
          }
        }

        if (this.formPagination == 2) {
          const duplicateEmail =
            this.certificatePayLoadData.certificationPartTwoRefererenceInformation.filter(
              (reference: any) => {
                if (
                  reference.referenceEmailAddress.toLowerCase() ===
                  this.certificatePayLoadData.certificationPartTwoApplicationForm.email.toLowerCase()
                ) {
                  return reference;
                }
              }
            );
          if (duplicateEmail.length) {
            this.errorMessage =
              "Applicant email id and reference email id must be different *";
            return;
          }
          const supervisorEmails =
            this.certificatePayLoadData.certificationPartTwoSupervisorInformation.map(
              (supervisor: any) => {
                return supervisor.supervisorEmail.toLowerCase();
              }
            );
          const supervisorReferenceDuplicateEmail =
            this.certificatePayLoadData.certificationPartTwoRefererenceInformation.filter(
              (reference: any) => {
                if (
                  supervisorEmails.includes(
                    reference.referenceEmailAddress.toLowerCase()
                  )
                ) {
                  return reference;
                }
              }
            );
          if (supervisorReferenceDuplicateEmail.length) {
            this.errorMessage =
              "Supervisor email id and reference email id must be different *";
            this.showForm(this.formName);
            return;
          }
        }

        this.isLoading = true;
        this.checkValidForm = false;
        this.isValid = true;
        // An autosave may be pending or in flight. Drop the pending one and wait
        // for the running one, so this updates the row the autosave created
        // instead of racing it and creating a second application.
        if (this.draftAutoSaveTimer) {
          clearTimeout(this.draftAutoSaveTimer);
          this.draftAutoSaveTimer = null;
        }
        await this.draftSave;
        if (!this.certificatePayLoadData.id) {
          await certificationFormApi
            .CertificationApplicationForm(
              this.certificatePayLoadData.fillStatus,
              this.certificatePayLoadData
            )
            .then((result: any) => {
              this.isLoading = false;
              this.certificateLocationId = result.headers.location;
              localStorage.setItem(
                "partTwoCertificateApplicationId",
                this.certificateLocationId
              );
              this.certificatePayLoadData.id = localStorage.getItem(
                "partTwoCertificateApplicationId"
              );
              this.markDraftSaved();
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          const applicationId = localStorage.getItem(
            "partTwoCertificateApplicationId"
          );
          let payloadStorage: any = localStorage.getItem(
            "partTwoCertificationPayload"
          );
          if (applicationId || payloadStorage) {
            payloadStorage = JSON.parse(payloadStorage);
            this.certificatePayLoadData.id =
              applicationId === null ? payloadStorage.id : applicationId;
          }
          const id = this.certificatePayLoadData.id;
          // Nothing has changed since the last save, so the step is already
          // on the server - move on rather than sending the same body again.
          if (this.draftSnapshot === this.lastSavedDraft) {
            this.isLoading = false;
            if (!this.isEdit) {
              this.nextPaginationUpdate();
            }
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          } else {
            await certificationFormApi
              .updateCertificationForm(this.certificatePayLoadData, id)
              .then(() => {
                this.isLoading = false;
                this.markDraftSaved();
                if (!this.isEdit) {
                  this.nextPaginationUpdate();
                }
                const el = document.getElementById(this.mainId);
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });
          }
        }
        if (this.isEdit) {
          this.formPagination = 5;
          this.formName = "certificationPartTwoApplicationForm";
        }
        if (!this.formCompletedIndex.includes(completedStep)) {
          this.formCompletedIndex.push(completedStep);
        }
        localStorage.setItem(
          "partTwoFormFilledIndex",
          this.formCompletedIndex.toString()
        );
        localStorage.setItem(
          "partTwoCertificationPayload",
          JSON.stringify(this.certificatePayLoadData)
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 50);
      }
    });
  }

  // The five data steps, in order; their index is also their tab index. Preview
  // is the tab right after the last one (index === dataStepSlugs.length).
  private dataStepSlugs: string[] = [
    "certificationPartTwoApplicationForm",
    "certificationPartTwoSupervisorInformation",
    "certificationPartTwoRefererenceInformation",
    "certificationPartTwoHandbook",
    "certificationPartTwoSignature",
  ];

  // First data step not yet completed via Next (which runs its full validation),
  // or -1 if all are done. Preview is only reachable when this returns -1.
  private firstIncompleteDataStep(): number {
    for (let i = 0; i < this.dataStepSlugs.length; i++) {
      if (!this.formCompletedIndex.includes(i)) {
        return i;
      }
    }
    return -1;
  }

  // Land on an incomplete step and surface its errors.
  private jumpToIncompleteStep(index: number) {
    this.isEdit = false;
    this.referenceEmailDuplicateIndexs = [];
    this.supervisorEmailDuplicateIndexs = [];
    this.formName = this.dataStepSlugs[index];
    this.formPagination = index;
    this.checkValidForm = true;
    this.showForm(this.formName);
    this.$nextTick(() => {
      this.$validator.validateAll().then(() => {
        // Let the error classes render, then scroll to the first missing field
        // (falling back to the top of the form if none is found).
        setTimeout(() => {
          const invalid = document.getElementsByClassName("is-invalid")[0];
          if (invalid) {
            invalid.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, 100);
      });
    });
  }

  public nextPaginationUpdate() {
    if (this.formPagination < this.formData.length - 1) {
      this.isNavLoad = true;
      const page = this.formPagination + 1;
      if (page == 0) {
        this.formName = "certificationPartTwoApplicationForm";
      } else if (page == 1) {
        this.formName = "certificationPartTwoSupervisorInformation";
      } else if (page == 2) {
        this.formName = "certificationPartTwoRefererenceInformation";
        this.showForm(this.formName);
      } else if (page == 3) {
        this.formName = "certificationPartTwoHandbook";
      } else if (page == 4) {
        this.formName = "certificationPartTwoSignature";
      }
      this.formPagination = page;
    }
  }

  public saveDraft() {
    this.$bvToast.show("example-toast");
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    localStorage.setItem(
      "partTwoCertificationPayload",
      JSON.stringify(this.certificatePayLoadData)
    );
    this.saveDataDraft = true;
    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "certificationPartTwoApplicationForm") {
      this.formPagination = 0;
    } else if (slug == "certificationPartTwoSupervisorInformation") {
      this.formPagination = 1;
    } else if (slug == "certificationPartTwoRefererenceInformation") {
      this.showForm(slug);
      this.formPagination = 2;
    }
    if (slug == "certificationPartTwoHandbook") {
      this.formPagination = 3;
    } else if (slug == "certificationPartTwoSignature") {
      this.certificatePayLoadData.certificationPartTwoSignature.isSignature =
        "";
      localStorage.setItem(
        "partTwoCertificationPayload",
        JSON.stringify(this.certificatePayLoadData)
      );
      this.formPagination = 4;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  public previousButton() {
    this.isEdit = false;
    this.referenceEmailDuplicateIndexs = [];
    this.supervisorEmailDuplicateIndexs = [];
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 0) {
        this.formName = "certificationPartTwoApplicationForm";
      } else if (this.formPagination == 1) {
        this.formName = "certificationPartTwoSupervisorInformation";
      } else if (this.formPagination == 2) {
        this.formName = "certificationPartTwoRefererenceInformation";
      } else if (this.formPagination == 3) {
        this.formName = "certificationPartTwoHandbook";
      } else if (this.formPagination == 4) {
        this.formName = "certificationPartTwoSignature";
      }
    }
  }
  public onSubmit() {
    this.$validator.validate().then((validate) => {
      if (validate) {
        this.certificatePayLoadData.certificationPartTwoApplicationForm.state =
          this.certificatePayLoadData.certificationPartTwoApplicationForm.state.toLocaleUpperCase();
        this.certificatePayLoadData.certificationPartTwoApplicationForm.submissionDate =
          moment().format("MM-DD-YYYY");
        let payloadStorage: any = localStorage.getItem(
          "partTwoCertificationPayload"
        );
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.certificatePayLoadData = {
            ...this.certificatePayLoadData,
            ...payloadStorage,
          };
        }
        this.isLoading = true;
        this.stopDraftAutoSave();
        this.certificatePayLoadData.fillStatus = "COMPLETED";
        this.certificatePayLoadData.id = localStorage.getItem(
          "partTwoCertificateApplicationId"
        );
        if (
          this.certificatePayLoadData.certificationPartTwoApplicationForm
            .backupEmail === ""
        ) {
          this.certificatePayLoadData.certificationPartTwoApplicationForm.backupEmail =
            null;
        }
        const id = this.certificatePayLoadData.id;
        certificationFormApi
          .updateCertificationForm(this.certificatePayLoadData, id)
          .then(() => {
            certificationFormApi
              .getCertificationApplicationForm(id)
              .then((result: any) => {
                const applicationCode = result.data.code;
                const applicationNameData = {
                  title: "Certified Peer Recovery Specialist Application",
                  SubTitle: "Certification: Part Two",
                };
                this.$router.push({
                  path: "/form/submitted",
                  query: {
                    subTitle: applicationNameData.SubTitle,
                    applicationId: applicationCode,
                  },
                });
                this.isLoading = false;
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
            localStorage.removeItem("partTwoCertificationPayload");
            localStorage.removeItem("partTwoCertificateApplicationId");
            localStorage.removeItem("partTwoFormFilledIndex");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public scopeOfActivityValidation(event: boolean) {
    this.validSOA = event;
  }

  // Fields registered with the validator (i.e. the current step is rendered).
  private validatorFieldCount(): number {
    try {
      const fields: any = (this.$validator as any).fields;
      return fields && fields.items ? fields.items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  // The checks Next runs on a step that vee-validate cannot see, so a silent
  // re-derivation judges a step exactly as Next would. Side-effect free: the
  // duplicate lookups are read here and thrown away rather than written to the
  // *DuplicateIndexs fields, and no popup or error message is raised, because
  // this runs while the user is on their way to another tab.
  /**
   * Payload rows come back from drafts that were saved by older shapes, so a
   * key can simply be absent. A bare .toLowerCase() on one of those throws, and
   * because these checks run inside navigateTab the throw took the tab click
   * with it — the click did nothing at all, with nothing in the console to say
   * why. Everything below reads through these two instead.
   */
  private lower(value: any): string {
    return typeof value === "string" ? value.toLowerCase() : "";
  }

  private duplicateRowIdx(section: string, field: string): number[] {
    const rows = this.certificatePayLoadData[section];
    if (!Array.isArray(rows)) {
      return [];
    }
    const seen = new Set<string>();
    const duplicates: number[] = [];
    rows.forEach((row: any, idx: number) => {
      const value = this.lower(row && row[field]);
      if (!value) {
        return;
      }
      if (seen.has(value)) {
        duplicates.push(idx);
      } else {
        seen.add(value);
      }
    });
    return duplicates;
  }

  /**
   * A refusal always has to say something. Validation errors and the messages
   * Next uses cover most of it, but a step can be held up by something with no
   * field to flag, and then the applicant is bounced to a tab that looks
   * perfectly fine and told nothing at all.
   */
  private announceBlockedStep(step: number) {
    setTimeout(() => {
      if (
        this.errorMessage ||
        document.getElementsByClassName("is-invalid").length
      ) {
        return;
      }
      const navName = (this.applicationNavData[step] || ({} as any)).name;
      const stepName = (navName || "").trim() || "this step";
      this.errorMessage = `Please complete ${stepName} before previewing the application.`;
    }, 300);
  }

  private stepExtraChecksPass(step: number): boolean {
    const payload = this.certificatePayLoadData;
    const applicantEmail = () =>
      this.lower((payload.certificationPartTwoApplicationForm || {}).email);
    if (step === 0) {
      return (
        (payload.certificationPartTwoApplicationForm || {})
          .completedTennessee !== "No"
      );
    }
    if (step === 1) {
      if (
        this.duplicateRowIdx(
          "certificationPartTwoSupervisorInformation",
          "supervisorEmail"
        ).length
      ) {
        return false;
      }
      const supervisors =
        payload.certificationPartTwoSupervisorInformation || [];
      return !supervisors.some(
        (supervisor: any) =>
          this.lower(supervisor && supervisor.supervisorEmail) ===
          applicantEmail()
      );
    }
    if (step === 2) {
      if (
        this.duplicateRowIdx(
          "certificationPartTwoRefererenceInformation",
          "referenceEmailAddress"
        ).length
      ) {
        return false;
      }
      const supervisorEmails = (
        payload.certificationPartTwoSupervisorInformation || []
      ).map((supervisor: any) =>
        this.lower(supervisor && supervisor.supervisorEmail)
      );
      const references =
        payload.certificationPartTwoRefererenceInformation || [];
      return !references.some((reference: any) => {
        const email = this.lower(reference && reference.referenceEmailAddress);
        if (!email) {
          return false;
        }
        return email === applicantEmail() || supervisorEmails.includes(email);
      });
    }
    if (step === 3) {
      // The Scope of Activity lives on the handbook tab, so its validity is
      // that tab's business — not a reason to unmark any other one.
      return this.validSOA;
    }
    if (step === this.dataStepSlugs.length - 1) {
      return !!(payload.certificationPartTwoSignature || {}).isSignature;
    }
    return true;
  }

  // Sync the rendered data step's completion from a live validation: mark it
  // complete only when every required field validates, and UNMARK it when a
  // stale/minimal-only completion is left over. Validated silently — errors are
  // cleared so nothing flashes as the user leaves the tab.
  //
  // Every data step is re-derived, not just the Application Form: a tab the
  // applicant filled in and then left by clicking another tab is finished
  // whether or not they pressed Next, and the Preview gate has to see that.
  // Without this, filling the last step and clicking Preview went nowhere — the
  // step was not marked, so the gate bounced the user straight back onto it.
  /**
   * Bring every step Preview is waiting on onto the screen and judge it exactly
   * as Next judges it. One that passes is marked and the walk moves on; the
   * first that genuinely fails is handed back so the applicant lands there with
   * its own errors showing.
   *
   * Preview is still only for an application that is actually finished — but
   * "finished" has to mean the data is there, not that the applicant happened to
   * press Next on every tab. Filling a tab and clicking Preview is a perfectly
   * ordinary thing to do, and it used to lead nowhere.
   *
   * Returns the step that blocks Preview, or -1 when nothing does.
   */
  private async settleIncompleteSteps(): Promise<number> {
    let step = this.firstIncompleteDataStep();
    if (step === -1) {
      return -1;
    }
    const landedOn = this.formPagination;
    this.isLoading = true;
    try {
      while (step !== -1) {
        if (!(await this.settleStep(step))) {
          return step;
        }
        const next = this.firstIncompleteDataStep();
        // A step that reports itself complete and still comes back as the first
        // incomplete one would spin here forever; stop and let the applicant see
        // it instead.
        if (next === step) {
          return step;
        }
        step = next;
      }
      return -1;
    } catch (error) {
      // The walk is a convenience, never a trap: if judging a step throws, put
      // the applicant back where they were rather than leaving the click dead.
      this.formPagination = landedOn;
      this.formName = this.dataStepSlugs[landedOn] || this.formName;
      return landedOn;
    } finally {
      this.isLoading = false;
    }
  }

  private async settleStep(step: number): Promise<boolean> {
    if (step !== this.formPagination) {
      // vee-validate only knows the fields currently rendered, so a step has to
      // be on screen before it can be judged.
      this.formName = this.dataStepSlugs[step];
      this.formPagination = step;
      this.showForm(this.formName);
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    this.prepareStepForCompletion(step);
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    if (valid && this.stepExtraChecksPass(step)) {
      this.markStepComplete(step);
      return true;
    }
    if (valid) {
      this.explainStepBlock(step);
    }
    return false;
  }

  // What Next fills in on the applicant's behalf before it will judge a step.
  // The submission date is the whole reason Signature could never be completed
  // by filling the form: it is required, and only Next ever wrote it.
  private prepareStepForCompletion(step: number) {
    if (
      step === this.dataStepSlugs.length - 1 &&
      this.certificatePayLoadData.certificationPartTwoSignature.isSignature
    ) {
      this.certificatePayLoadData.certificationPartTwoSignature.submissionDate =
        moment().format("MM-DD-YYYY");
    }
  }

  // Say out loud why a tab is holding Preview up, in the words Next uses. The
  // conflicts below are invisible to vee-validate, so without this the applicant
  // is bounced back to a tab with every field filled and nothing flagged.
  private explainStepBlock(step: number) {
    const payload = this.certificatePayLoadData;
    const applicantEmail =
      payload.certificationPartTwoApplicationForm.email.toLowerCase();
    if (step === 0) {
      const content: any = this.formData.find(
        (form: any) =>
          form.parent_slug === "certificationPartTwoApplicationForm"
      );
      this.eligibilityPopupMsg = content?.fields?.completedTennesseePopupMsg;
      this.eligibilityPopup = true;
      return;
    }
    if (step === 1) {
      this.supervisorEmailDuplicateIndexs = this.duplicateRowIdx(
        "certificationPartTwoSupervisorInformation",
        "supervisorEmail"
      );
      if (!this.supervisorEmailDuplicateIndexs.length) {
        this.errorMessage =
          "Supervisor email id and applicant email id must be different *";
      }
      return;
    }
    if (step === 2) {
      this.referenceEmailDuplicateIndexs = this.duplicateRowIdx(
        "certificationPartTwoRefererenceInformation",
        "referenceEmailAddress"
      );
      if (this.referenceEmailDuplicateIndexs.length) {
        return;
      }
      const supervisorEmails =
        payload.certificationPartTwoSupervisorInformation.map(
          (supervisor: any) => supervisor.supervisorEmail.toLowerCase()
        );
      const clashesWithSupervisor =
        payload.certificationPartTwoRefererenceInformation.some(
          (reference: any) =>
            supervisorEmails.includes(
              reference.referenceEmailAddress.toLowerCase()
            )
        );
      this.errorMessage = clashesWithSupervisor
        ? "Supervisor email id and reference email id must be different *"
        : "Applicant email id and reference email id must be different *";
      return;
    }
    if (step === 3) {
      this.checkSOAValid = !this.checkSOAValid;
      return;
    }
    if (step === this.dataStepSlugs.length - 1) {
      this.signatureInvalid = true;
    }
  }

  // Record a step as completed. The silent pass and the Preview gate both land
  // here so there is one definition of "done" and one write to storage.
  private markStepComplete(step: number) {
    if (!this.formCompletedIndex.includes(step)) {
      this.formCompletedIndex.push(step);
    }
    localStorage.setItem(
      "partTwoFormFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  private async markCurrentStepIfComplete() {
    try {
      await this.deriveCurrentStepCompletion();
    } catch (error) {
      // Judging a step is a convenience. If it throws, the applicant still gets
      // to change tabs — the gate below decides what happens next.
    }
  }

  private async deriveCurrentStepCompletion() {
    const step = this.formPagination;
    if (step >= this.dataStepSlugs.length || this.validatorFieldCount() === 0) {
      return;
    }
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    const complete = valid && this.stepExtraChecksPass(step);
    const idx = this.formCompletedIndex.indexOf(step);
    if (complete) {
      this.markStepComplete(step);
    } else if (step === 0 && idx !== -1) {
      // Only Basic Details is ever unmarked here, which is what this check was
      // written for: a draft row exists from an email alone, so a stale mark has
      // to be corrected. A later step was marked by Next, which validated the
      // whole tab with everything rendered — a silent re-check that cannot see
      // as much must not be allowed to take that away and strand the applicant
      // on a tab that looks finished.
      this.formCompletedIndex.splice(idx, 1);
      localStorage.setItem(
        "partTwoFormFilledIndex",
        this.formCompletedIndex.toString()
      );
    }
  }

  // On load, once the Application Form has rendered, re-derive its completion so
  // a stale "complete" mark (e.g. from an earlier minimal draft) is corrected.
  private async syncStepZeroOnLoad() {
    let tries = 0;
    while (
      tries++ < 30 &&
      (this.formData.length === 0 || this.validatorFieldCount() === 0)
    ) {
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    await this.markCurrentStepIfComplete();
  }

  /**
   * The payload section the rendered step edits. The template must never index
   * the payload directly: Preview is a step with no section of its own, and a
   * draft restored from an older shape can be missing one — either way an
   * undefined section throws on every render, which blanks the form and fills
   * the console rather than showing the step.
   */
  get currentSection() {
    return this.certificatePayLoadData[this.formName] || {};
  }

  public async navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Leaving a data step: mark it complete only if fully valid, so the Preview
    // and finalize gates see a tab the applicant finished and left by clicking
    // another tab, Next or no Next. Jumping away from an unfinished tab is
    // allowed — it just does not get marked complete.
    await this.markCurrentStepIfComplete();
    // Reaching Preview requires every data step completed. If any is incomplete,
    // jump to the first one instead.
    if (index === this.dataStepSlugs.length) {
      const blocked = await this.settleIncompleteSteps();
      if (blocked !== -1) {
        this.jumpToIncompleteStep(blocked);
        this.announceBlockedStep(blocked);
        return;
      }
    }
    this.isEdit = false;
    this.referenceEmailDuplicateIndexs = [];
    this.supervisorEmailDuplicateIndexs = [];
    // Auto-save the current part as a draft before leaving it.
    this.persistDraft();
    // Preview has no payload section of its own, but the step still owns the
    // slug: the template decides which block to render from formName, so
    // pinning it to the previous step rendered that step's fields on the
    // Preview tab. Nothing may index the payload by formName without a
    // fallback — the currentSection getter is what keeps an absent section
    // from throwing.
    this.formName = slug;
    this.formPagination = index;
    this.showForm(this.formName);
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Persist the current payload as a draft (fillStatus stays DRAFT) without
  // validation — used when jumping between parts. The row already exists.
  // Draft saves are chained rather than fired in parallel: navigateTab does not
  // await this (the tab switches immediately), so jumping several tabs quickly
  // would otherwise leave overlapping PUTs racing, and the last response to
  // land wins regardless of the order they were sent.
  /*
   * The payload as it was at the last successful save. Every save path sends
   * the whole application, and there are four of them - Next, the stepper
   * tabs, Save Draft and Submit - so a five step form put the same unchanged
   * body five times over a normal run. Comparing against this skips a save
   * that would not change anything on the server; a real edit still saves,
   * because the serialized payload differs.
   */
  private lastSavedDraft = "";

  private get draftSnapshot(): string {
    return JSON.stringify(this.certificatePayLoadData);
  }

  private markDraftSaved() {
    this.lastSavedDraft = this.draftSnapshot;
  }

  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "partTwoCertificationPayload",
      JSON.stringify(this.certificatePayLoadData)
    );
  }

  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave.then(() => this.saveDraftNow());
    return this.draftSave;
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs an email: fetchDetailsfromData() in the workflow API
   * keys the row on it (and rejects the save without a valid one), so the row is
   * created the moment a valid email exists and updated on every save after
   * that. Before then the draft is local-only, which is silent by design — the
   * applicant has not given us anything to file it under yet, so a failed save
   * is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "partTwoCertificationPayload",
      JSON.stringify(this.certificatePayLoadData)
    );
    const app = this.certificatePayLoadData.certificationPartTwoApplicationForm;
    if (!this.certificatePayLoadData.id) {
      if (!utils.canSaveDraftRemotely(app.email)) {
        return;
      }
      try {
        const result: any =
          await certificationFormApi.CertificationApplicationForm(
            this.certificatePayLoadData.fillStatus,
            this.certificatePayLoadData
          );
        this.certificateLocationId = result.headers.location;
        localStorage.setItem(
          "partTwoCertificateApplicationId",
          this.certificateLocationId
        );
        this.certificatePayLoadData.id = this.certificateLocationId;
        localStorage.setItem(
          "partTwoCertificationPayload",
          JSON.stringify(this.certificatePayLoadData)
        );
        this.markDraftSaved();
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    if (this.draftSnapshot === this.lastSavedDraft) {
      return;
    }
    try {
      await certificationFormApi.updateCertificationForm(
        this.certificatePayLoadData,
        this.certificatePayLoadData.id
      );
      this.markDraftSaved();
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the applicant prefill do not count as filling anything in. From
  // the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "certificatePayLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
    // The header was hidden with "remove-container" when this form opened;
    // put it back however the form is left (Back button, menu, route change).
    const headerEl = document.getElementById("header");
    if (headerEl) {
      headerEl.classList.add("active");
      headerEl.classList.remove("remove-container");
    }
  }

  public fieldUpdate(groupName = "") {
    switch (groupName) {
      case "completedTennessee":
        if (
          this.certificatePayLoadData.certificationPartTwoApplicationForm
            .completedTennessee === "No"
        ) {
          // this.eligibilityPopup = true;
        }
        break;
      case "stillEmployed":
        if (
          this.certificatePayLoadData.certificationPartTwoApplicationForm
            .stillEmployed === "No"
        ) {
          if (this.hideDiv.indexOf("endDate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("endDate"), 1);
          }
          if (this.hideDiv.indexOf("startDate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("startDate"), 1);
          }
        } else if (
          this.certificatePayLoadData.certificationPartTwoApplicationForm
            .stillEmployed === "Yes"
        ) {
          if (!this.hideDiv.includes("endDate")) {
            this.hideDiv.push("endDate");
            this.certificatePayLoadData.certificationPartTwoApplicationForm.endDate =
              "";
          }
          if (this.hideDiv.indexOf("startDate") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("startDate"), 1);
          }
        }
        break;
      default:
        break;
    }
  }

  public changeStateForTraining(value: string) {
    if (value === "false") {
      return "true";
    } else {
      return "false";
    }
  }

  public showForm(formName: string) {
    // Preview, and any section a draft did not carry, have nothing to lay out
    // here — and this runs on every tab change, Preview included.
    const formData = this.certificatePayLoadData[formName];
    if (formData && formData.length) {
      if (formName === "certificationPartTwoRefererenceInformation") {
        this.addReferenceForm = [];
      }
      formData.forEach(() => {
        if (formName === "certificationPartTwoRefererenceInformation") {
          this.addReferenceForm.push(this.formData[2].fields.multiForm[0]);
        }
      });
    }
  }

  public pushForm(formName: string) {
    if (formName === "certificationPartTwoRefererenceInformation") {
      this.addReferenceForm.push(this.formData[2].fields.multiForm[0]);
      this.certificatePayLoadData.certificationPartTwoRefererenceInformation.push(
        {
          firstName: "",
          lastName: "",
          agencyOrganization: "",
          yourPosition: "",
          referencePhoneNumber: "",
          referenceEmailAddress: "",
          reference:
            this.certificatePayLoadData
              .certificationPartTwoRefererenceInformation.length + 1,
        }
      );
    }
  }

  public addAnother() {
    this.certificatePayLoadData.certificationPartTwoSupervisorInformation.push({
      supervisorFirstName: "",
      supervisorLastName: "",
      supervisorAgencyOrganization: "",
      supervisorPhone: "",
      supervisorEmail: "",
    });

    this.supervisorFormFields.push(
      this.applicationData[0].attributes.certification_form_fields[1].fields
        .formInputs[0]
    );
    this.supervisorUIUpdate = utils.UIUpdateUsingKey(this.supervisorUIUpdate);
  }

  public removeAddedSupervisor(indexForm: number) {
    this.certificatePayLoadData.certificationPartTwoSupervisorInformation.splice(
      indexForm,
      1
    );
    this.supervisorFormFields.splice(indexForm, 1);
    this.supervisorUIUpdate = utils.UIUpdateUsingKey(this.supervisorUIUpdate);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }
  public goBack() {
    if (this.$route.query.isDraft) {
      localStorage.removeItem("partTwoCertificationPayload");
    }
    this.$router.push({
      path: `/application`,
      query: {
        form: "part-two",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
  public closedEligibilityPopup(event: any) {
    this.eligibilityPopup = false;
    if (event) {
      this.goBack();
    }
  }
}
